// extracted by mini-css-extract-plugin
export default {"mb25":"PanelDetail_mb25__MntHN"};